import type { Bundle } from '../types'

/** Vocabulaire partagé par tous les écrans : actions, états de chargement, tableaux. */
export const common = {
  'common.loading': { fr: 'Chargement…', en: 'Loading…' },
  'common.save': { fr: 'Enregistrer', en: 'Save' },
  'common.saving': { fr: 'Enregistrement…', en: 'Saving…' },
  'common.cancel': { fr: 'Annuler', en: 'Cancel' },
  'common.close': { fr: 'Fermer', en: 'Close' },
  'common.create': { fr: 'Créer', en: 'Create' },
  'common.edit': { fr: 'Modifier', en: 'Edit' },
  'common.delete': { fr: 'Supprimer', en: 'Delete' },
  'common.deleteShort': { fr: 'Suppr.', en: 'Delete' },
  'common.add': { fr: 'Ajouter', en: 'Add' },
  'common.search': { fr: 'Rechercher', en: 'Search' },
  'common.searching': { fr: 'Recherche…', en: 'Searching…' },
  'common.filter': { fr: 'Filtrer', en: 'Filter' },
  'common.reset': { fr: 'Réinitialiser', en: 'Reset' },
  'common.retry': { fr: 'Réessayer', en: 'Retry' },
  'common.refresh': { fr: 'Rafraîchir', en: 'Refresh' },
  'common.back': { fr: 'Retour', en: 'Back' },
  'common.next': { fr: 'Suivant', en: 'Next' },
  'common.previous': { fr: 'Précédent', en: 'Previous' },
  'common.confirm': { fr: 'Confirmer', en: 'Confirm' },
  'common.apply': { fr: 'Appliquer', en: 'Apply' },
  'common.applying': { fr: 'Application…', en: 'Applying…' },
  'common.export': { fr: 'Exporter', en: 'Export' },
  'common.exporting': { fr: 'Export…', en: 'Exporting…' },
  'common.import': { fr: 'Importer', en: 'Import' },
  'common.importing': { fr: 'Import…', en: 'Importing…' },
  'common.open': { fr: 'Ouvrir', en: 'Open' },
  'common.details': { fr: 'Détail', en: 'Details' },
  'common.all': { fr: 'Tous', en: 'All' },
  'common.allF': { fr: 'Toutes', en: 'All' },
  'common.none': { fr: 'Aucun', en: 'None' },
  'common.yes': { fr: 'Oui', en: 'Yes' },
  'common.no': { fr: 'Non', en: 'No' },
  'common.unknown': { fr: 'Inconnu', en: 'Unknown' },
  'common.total': { fr: 'Total', en: 'Total' },
  'common.actions': { fr: 'Actions', en: 'Actions' },
  'common.status': { fr: 'Statut', en: 'Status' },
  'common.country': { fr: 'Pays', en: 'Country' },
  'common.countries': { fr: 'Pays', en: 'Countries' },
  'common.allCountries': { fr: 'Tous les pays', en: 'All countries' },
  'common.period': { fr: 'Période', en: 'Period' },
  'common.date': { fr: 'Date', en: 'Date' },
  'common.name': { fr: 'Nom', en: 'Name' },
  'common.url': { fr: 'URL', en: 'URL' },
  'common.domain': { fr: 'Domaine', en: 'Domain' },
  'common.brand': { fr: 'Marque', en: 'Brand' },
  'common.brands': { fr: 'Marques', en: 'Brands' },
  'common.merchant': { fr: 'Marchand', en: 'Merchant' },
  'common.merchants': { fr: 'Marchands', en: 'Merchants' },
  'common.category': { fr: 'Catégorie', en: 'Category' },
  'common.score': { fr: 'Score', en: 'Score' },
  'common.source': { fr: 'Source', en: 'Source' },
  'common.notes': { fr: 'Notes', en: 'Notes' },
  'common.comment': { fr: 'Commentaire', en: 'Comment' },
  'common.reason': { fr: 'Motif', en: 'Reason' },
  'common.role': { fr: 'Rôle', en: 'Role' },
  'common.email': { fr: 'Adresse courriel', en: 'Email address' },
  'common.password': { fr: 'Mot de passe', en: 'Password' },
  'common.organization': { fr: 'Organisation', en: 'Organisation' },
  'common.modules': { fr: 'Modules', en: 'Modules' },
  'common.platform': { fr: 'Plateforme', en: 'Platform' },
  'common.type': { fr: 'Type', en: 'Type' },
  'common.severity': { fr: 'Gravité', en: 'Severity' },
  'common.assignee': { fr: 'Attribué à', en: 'Assigned to' },
  'common.unassigned': { fr: 'Non attribué', en: 'Unassigned' },
  'common.overdue': { fr: 'En retard', en: 'Overdue' },
  'common.detectedAt': { fr: 'Détecté le', en: 'Detected on' },
  'common.updatedAt': { fr: 'Mis à jour le', en: 'Updated on' },
  'common.createdAt': { fr: 'Créé le', en: 'Created on' },
  'common.never': { fr: 'Jamais', en: 'Never' },
  'common.optional': { fr: 'facultatif', en: 'optional' },
  'common.required': { fr: 'obligatoire', en: 'required' },
  'common.noResult': { fr: 'Aucun résultat', en: 'No results' },
  'common.noData': { fr: 'Aucune donnée', en: 'No data' },
  'common.selected': { fr: '{n} sélectionné(s)', en: '{n} selected' },
  'common.ofTotal': { fr: '{shown} sur {total}', en: '{shown} of {total}' },
  'common.page': { fr: 'Page {page} / {pages}', en: 'Page {page} of {pages}' },
  'common.copy': { fr: 'Copier', en: 'Copy' },
  'common.copied': { fr: 'Copié', en: 'Copied' },
  'common.seeAll': { fr: 'Voir tout', en: 'See all' },
  'common.showMore': { fr: 'Voir plus', en: 'Show more' },
  'common.showLess': { fr: 'Voir moins', en: 'Show less' },
  'common.hide': { fr: 'Masquer', en: 'Hide' },
  'common.deleteConfirm': { fr: 'Supprimer « {name} » ? Cette action est irréversible.', en: 'Delete “{name}”? This cannot be undone.' },

  // Sélecteur de langue
  'lang.label': { fr: 'Langue', en: 'Language' },
  'lang.choose': { fr: "Langue de l'interface", en: 'Interface language' },

  // Thème
  'theme.label': { fr: "Thème de l'interface", en: 'Interface theme' },
  'theme.light': { fr: 'Clair', en: 'Light' },
  'theme.dark': { fr: 'Sombre', en: 'Dark' },
  'theme.named': { fr: 'Thème {name}', en: '{name} theme' },
  'theme.switchToDark': { fr: 'Passer en thème sombre', en: 'Switch to dark theme' },
  'theme.switchToLight': { fr: 'Passer en thème clair', en: 'Switch to light theme' },
  'theme.darkShort': { fr: 'Thème sombre', en: 'Dark theme' },
  'theme.lightShort': { fr: 'Thème clair', en: 'Light theme' },

  // Périodes
  'period.days7': { fr: '7 derniers jours', en: 'Last 7 days' },
  'period.days30': { fr: '30 derniers jours', en: 'Last 30 days' },
  'period.months3': { fr: '3 derniers mois', en: 'Last 3 months' },
  'period.months12': { fr: '12 derniers mois', en: 'Last 12 months' },
} satisfies Bundle
